import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input } from 'semantic-ui-react'

class SchoolYearsAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      code: '',
      startDate: '',
      endDate: '',
      showModal: false,
    };
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSubmit = () => {
    const data = {
      name: this.state.name,
      code: this.state.code,
      startDate: this.state.startDate,
      endDate: this.state.endDate
    };
    this.props.handleSubmit(data);
    this.setState({
      name: '',
      code: '',
      startDate: '',
      endDate: '',
    })
    this.closeModal();
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  render() {

    return (
      <Modal
        trigger={
          <Button icon floated='right' labelPosition='right' color='green' onClick={this.openModal}> <Icon name='add' />
          Add School Year
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>Add School Year</Modal.Header>
        <Modal.Content>
        <Form>
          <Form.Group widths='equal'>
            <Form.Field control={Input} value={this.state.name} name='name' label='Name' placeholder='Name' onChange={this.handleChange}/>
            <Form.Field control={Input} value={this.state.code} name='code' label='Code' placeholder='Code' onChange={this.handleChange}/>
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Field>
              <label>Start Date</label>
              <Input value={this.state.startDate} name='startDate' type='date' placeholder='Start Date' onChange={this.handleChange}/>
            </Form.Field>
            <Form.Field>
              <label>End Date</label>
              <Input value={this.state.endDate} name='endDate' type='date' placeholder='endDate' onChange={this.handleChange}/>
            </Form.Field>
          </Form.Group>
        </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.handleSubmit()}>Submit</Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default SchoolYearsAdd;
